(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(53678);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Index": function() { return /* binding */ Index; },
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10092);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(35944);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71750);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _base_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11965);
/* harmony import */ var _components_AddCompany_AddCompanyModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44607);
/* harmony import */ var _components_LoginSignup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22588);
/* harmony import */ var _components_LoginSignup_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17896);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(90993);
/* harmony import */ var _theme_variables__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81653);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44108);















var __N_SSP = true;
var Index = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)([
        "common"
    ]).t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var actions = (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useOrganizationContext */ .mP)().actions;
    var hasRedirected = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(false);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isAddOrgModalOpen = ref[0], setIsAddOrgModalOpen = ref[1];
    var onLoginFinish = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(user) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, organizations, defaultOrg, orgId, matchedOrg, redirectParam, redirectQuery, orgRedirect, start, end, itemUrl, itemRedirect, redirectTarget, destination, phoneRedirect, isVerified;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                organizations = (user === null || user === void 0 ? void 0 : user.organizations) || [];
                if (!organizations.length) {
                    setIsAddOrgModalOpen(true);
                    return [
                        2
                    ];
                }
                setIsAddOrgModalOpen(false);
                defaultOrg = user === null || user === void 0 ? void 0 : (ref = user["default-profile"]) === null || ref === void 0 ? void 0 : ref.organization;
                orgId = defaultOrg === null || defaultOrg === void 0 ? void 0 : defaultOrg.id;
                matchedOrg = organizations.find(function(ORG) {
                    return ORG.organization.id === (defaultOrg === null || defaultOrg === void 0 ? void 0 : defaultOrg.id);
                });
                if (matchedOrg) {
                    actions.setOrg({
                        updateRoute: false,
                        newOrg: matchedOrg.organization,
                        makeRequest: true
                    });
                }
                redirectParam = router.query.redirect;
                redirectQuery = Array.isArray(redirectParam) ? redirectParam[0] : redirectParam;
                orgRedirect = orgId ? "/reservations/".concat(orgId, "?tab=upcoming") : "/reservations";
                start = Array.isArray(router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.start) ? router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.start[0] : router === null || router === void 0 ? void 0 : (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.start;
                end = Array.isArray(router === null || router === void 0 ? void 0 : (ref4 = router.query) === null || ref4 === void 0 ? void 0 : ref4.end) ? router === null || router === void 0 ? void 0 : (ref5 = router.query) === null || ref5 === void 0 ? void 0 : ref5.end[0] : router === null || router === void 0 ? void 0 : (ref6 = router.query) === null || ref6 === void 0 ? void 0 : ref6.end;
                itemUrl = Array.isArray(router === null || router === void 0 ? void 0 : (ref7 = router.query) === null || ref7 === void 0 ? void 0 : ref7.item_url) ? router === null || router === void 0 ? void 0 : (ref8 = router.query) === null || ref8 === void 0 ? void 0 : ref8.item_url[0] : router === null || router === void 0 ? void 0 : (ref9 = router.query) === null || ref9 === void 0 ? void 0 : ref9.item_url;
                itemRedirect = itemUrl ? start ? "".concat(itemUrl, "?start=").concat(start).concat(end ? "&end=".concat(end) : "") : itemUrl : undefined;
                redirectTarget = redirectQuery && redirectQuery.length > 0 ? redirectQuery : orgRedirect;
                destination = itemRedirect || redirectTarget;
                if (!(user === null || user === void 0 ? void 0 : user["phone-number-verified"])) {
                    phoneRedirect = "/account/create/phone?updatePhone=true&redirect=".concat(encodeURIComponent(destination));
                    router.replace(phoneRedirect);
                    return [
                        2
                    ];
                }
                isVerified = user === null || user === void 0 ? void 0 : user["phone-number-verified"];
                if (!isVerified) {
                    router.push("/account/create/phone?updatePhone=true&redirect=".concat(encodeURIComponent(destination)));
                    return [
                        2
                    ];
                }
                if (itemRedirect) {
                    router.push(_utils_helpers__WEBPACK_IMPORTED_MODULE_10__/* .taxonomicalHref */ .bQ, itemRedirect);
                } else {
                    router.replace(redirectTarget);
                }
                return [
                    2
                ];
            });
        });
        return function onLoginFinish(user) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref1 = (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useUser */ .aF)(), contextUser = ref1.user;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (!router.isReady) return;
        if (!(contextUser === null || contextUser === void 0 ? void 0 : contextUser.id)) return;
        if (hasRedirected.current) return;
        hasRedirected.current = true;
        onLoginFinish(contextUser);
    }, [
        contextUser,
        router.isReady
    ]);
    var onSignupFinish = function(user) {
        if (user) {
            onLoginFinish(user);
            return;
        }
        var queryParam = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_10__/* .getQueryParam */ .Ph)(router.query);
        router.push("/reservations".concat(queryParam));
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .Fragment */ .HY, {
        children: [
            isAddOrgModalOpen && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_components_AddCompany_AddCompanyModal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                isOpen: isAddOrgModalOpen,
                setIsOpen: setIsAddOrgModalOpen,
                forceOpen: true,
                onSuccess: onLoginFinish
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)("title", {
                    children: "Kingbee Vans | ".concat(t("common:login.logIn"))
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_base_components__WEBPACK_IMPORTED_MODULE_4__/* .FlexCol */ .Ht, {
                "data-test-id": "login-page",
                mt: 10,
                mx: {
                    base: "".concat(_theme_variables__WEBPACK_IMPORTED_MODULE_9__/* .padding.topNav.mobileLeft */ .o3.topNav.mobileLeft, "px"),
                    lg: "".concat(_theme_variables__WEBPACK_IMPORTED_MODULE_9__/* .padding.topNav.left */ .o3.topNav.left, "px")
                },
                alignItems: "center",
                children: (contextUser === null || contextUser === void 0 ? void 0 : contextUser.id) && !isAddOrgModalOpen ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_base_components__WEBPACK_IMPORTED_MODULE_4__/* .SpinnerContainer */ .eg, {
                    py: 16,
                    "data-test-id": "login-redirecting"
                }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_components_LoginSignup_styles__WEBPACK_IMPORTED_MODULE_7__/* .SignUpLoginContainer */ .bg, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_components_LoginSignup__WEBPACK_IMPORTED_MODULE_6__/* .LoginSignup */ .st, {
                        loginProps: {
                            onFinish: onLoginFinish
                        },
                        signupProps: {
                            onFinish: onSignupFinish
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);